import React from 'react';
import { X } from 'lucide-react';
import { cn } from '../../shared/utils';

const Modal = ({ isOpen, onClose, title, children, className }) => {
    if (!isOpen) return null;

    return (
        // On a phone the dialog is a bottom sheet: full width, capped at the screen
        // height, title pinned and the body scrolling, so long forms stay reachable.
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-end md:items-center justify-center z-50 p-0 md:p-4">
            <div className={cn("modal-panel bg-white dark:bg-slate-800 rounded-t-2xl md:rounded-xl shadow-2xl w-full max-w-md overflow-hidden flex flex-col max-h-[92dvh] md:max-h-[90vh] animate-in fade-in zoom-in duration-200", className)}>
                <div className="flex justify-between items-center p-4 border-b border-slate-100 dark:border-slate-700 shrink-0">
                    <h3 className="font-semibold text-lg text-slate-800 dark:text-white">{title}</h3>
                    <button onClick={onClose} aria-label="Close" className="p-2 -m-1 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-full transition-colors">
                        <X size={20} className="text-slate-500" />
                    </button>
                </div>
                <div className="p-4 overflow-y-auto pb-safe">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Modal;
